import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ThemeService } from 'src/app/shared/services';
import { ThemeType } from '../models';
/**
 * This pipe is responsible for adding the '-dark' extension to the name of an image if the current theme is dark.
 * It uses the ThemeService to determine the current theme and applies the extension accordingly.
 */
@Pipe({
    name: 'imgType',
    standalone: true,
})
export class ImgTypePipe implements PipeTransform {
    constructor(private themeService: ThemeService) {}

    transform(value: string): Observable<string> {
        return this.themeService.getTheme().pipe(
            map((theme) => {
                return theme === ThemeType.dark ? value + '-dark' : value;
            })
        );
    }
}
